import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {EventDetailsView} from './eventsDetails/eventDetails.view';
import {EventDetailsStopView} from './eventsDetails/eventDetailsStop/eventDetailsStop.view';
import {ComponentsModule} from '../../components/components.module';
import {FrontPipesModule} from '../../pipes/pipes.module';
import {FrontDirectivesModule} from '../../directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        FrontPipesModule,
        FrontDirectivesModule,
        RouterModule,
        ComponentsModule,
        IonicModule
    ],
    declarations: [
        EventDetailsView,
        EventDetailsStopView
    ]
})
export class EventsModule {
}
